import React from 'react';
import { MessageCircle, CalendarCheck, FileCheck } from 'lucide-react';
import { howItWorks } from '../data/mock';

const iconMap = {
  1: <MessageCircle size={24} />,
  2: <CalendarCheck size={24} />,
  3: <FileCheck size={24} />,
};

const HowItWorksSection = () => {
  return (
    <section className="section-padding">
      <div className="container px-4 sm:px-10">
        {/* Section Header */}
        <div className="section-title">
          <p className="eyebrow-gold uppercase tracking-widest mb-4">
            Simple Process
          </p>
          <h2 className="heading-1">How It Works</h2>
          <p className="body-regular mt-4">
            Three simple steps to protection clarity.
          </p>
        </div>
        
        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {howItWorks.map((step) => (
            <div key={step.step} className="step-card">
              <div className="step-number">
                {step.step}
              </div>
              <h3 className="heading-3 mb-4">{step.title}</h3>
              <p className="body-small text-[var(--text-secondary)]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Connector Line (Desktop) */}
        <div className="hidden md:block relative max-w-4xl mx-auto -mt-32">
          <div className="absolute top-1/2 left-[16%] right-[16%] h-px bg-[var(--border-light)]" style={{ zIndex: -1 }}></div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
